import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`


  query formtemplate($organizationId: UUID!) {
    formTemplates(organizationId: $organizationId)  {
      created_by_account_id
      created_ts
      id
      organization_id
      title      
      type_id
      updated_ts
      type
    }
}
`;



export function apiGetFormTemplates(organizationId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: query,
                variables: {organizationId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.formTemplates);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get form templates");
                reject(err); // R
            })
    });
}
